






































import { PropType } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BulletinEntity } from '@/entities/bulletin.entity';
import { mapActions } from 'vuex';

@Component<BulletinItem>({
  methods: {
    ...mapActions('staff', ['fetchCurrentStaff']),
  },
})
export default class BulletinItem extends Vue {
  fetchCurrentStaff!: () => Promise<void>;

  @Prop({ type: Object as PropType<BulletinEntity> })
  bulletin: BulletinEntity;

  get IsShowItem() {
    return Number(this.bulletin.unreadNotify) > 0;
  }
}
